import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Ad } from './types';
import { adsQueryConfig } from './useGetAds';

/**
 * Pojedyncza reklama — wycinana z listy katalogu, a nie dociągana osobno.
 * Katalog jest mały i tak czy siak wisi w cache po wejściu na `/ads`, a dzięki
 * temu wejście z linka prosto na `/ads/:id/edit` samo pobiera to, czego trzeba,
 * bez drugiego endpointu.
 */
export const useGetAd = (
  adId: string | undefined,
): UseQueryResult<Ad | null, AxiosError> => useQuery<Ad[], AxiosError, Ad | null>({
  ...adsQueryConfig,
  select: (ads) => ads.find((ad) => ad.id === adId) ?? null,
});
